module.exports = __webpack_public_path__ + "img/mullins-ringed-city-2.93f0ef64.jpg";